import { render, staticRenderFns } from "./NfDropdownMenu.vue?vue&type=template&id=246a20a4&scoped=true&"
import script from "./NfDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./NfDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./NfDropdownMenu.vue?vue&type=style&index=0&id=246a20a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246a20a4",
  null
  
)

export default component.exports